@if (userStore.definedUserData()){
    @if(currentUser){
        <div class="flex items-center">
            @if(platformAdminRole && (platformAdminRole === 'owner' || platformAdminRole === 'manager')){
                <nav class="mx-auto h-full container gap-4 w-32 items-center mt-2  top-0 right-0 px-2 bg-transparent text-right" aria-label="Global">
                    <a
                            [routerLink]="['/admin']"
                            [routerLinkActive]="['text-primary']"
                            class="text-sm flex items-center h-full justify-start gap-2 text-normal hover:text-primary-hover"
                            [ngClass]="{'active': isActive('/create-merch-shop-for-video-blog')}"
                            appTooltip="{{'admin_panel' | translate}}"
                            [placement]="'bottom'"
                    >
                        <svg width="24" height="24" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="3.5" y="3.5" width="6" height="6" stroke="currentColor"/>
                            <rect x="3.5" y="12.5" width="6" height="6" stroke="currentColor"/>
                            <rect x="12.5" y="3.5" width="6" height="6" stroke="currentColor"/>
                            <rect x="12.25" y="15.75" width="0.5" height="6.5" transform="rotate(-90 12.25 15.75)" stroke="currentColor" stroke-width="0.5"/>
                            <rect x="15.25" y="12.25" width="0.5" height="6.5" stroke="currentColor" stroke-width="0.5"/>
                        </svg>
                        {{'admin' | translate}}
                    </a>
                </nav>
            }
        </div>
    } @else {
        <div class="hidden md:flex justify-end gap-4 items-center">
            @if (whiteLabel?.userManagement === undefined || whiteLabel?.userManagement?.auth_flow){
<!--                <a [routerLink]="['/auth/signup']"-->
<!--                   class="rounded-md px-4 py-2 cursor-pointer text-normal"-->
<!--                >-->
<!--                    {{'signup' | translate}}-->
<!--                </a>-->
                <a [routerLink]="['/auth/signin']"
                   class="md:flex gap-2 rounded-md px-4 py-2 cursor-pointer text-normal bg-primary"
                >
                    {{'signin' | translate}}
                </a>
            } @else{
                @if (whiteLabel?.userManagement?.auth_replace_link_label && whiteLabel.userManagement?.auth_replace_link_url){
                    <div class="hidden lg:flex lg:flex-1 lg:justify-end">
                        <a href="{{ whiteLabel.userManagement?.auth_replace_link_url }}" class="text-sm/6 font-semibold text-normal">
                            {{ whiteLabel.userManagement?.auth_replace_link_label }}
                            <span aria-hidden="true">&rarr;</span>
                        </a>
                    </div>
                }

            }
        </div>
    }
}
